import React from "react";
import { Layout } from "../../components/Layout";
import { Breadcrumbs } from "../../components/Breadcrumbs";
import { PostTagForm } from "../../forms/PostTagForm";
import Typography from "@material-ui/core/Typography";
import { RouteChildrenProps } from "react-router";
import { Link } from "react-router-dom";
import { useDetail } from "../../useAPI";
import { PostTag } from "../../types/PostTag";
import { updateTag } from "../../actions/tag/updateTag";
import { deleteTag } from "../../actions/tag/deleteTag";

export function InterviewTagEdit(
  props: RouteChildrenProps<{
    tagId: string;
  }>
) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const tagId = props.match!.params.tagId;
  const { data, error } = useDetail<PostTag>("interview-tags", tagId);

  return (
    <Layout>
      <Breadcrumbs>
        <Link to={"/interview-tags"}>Interview Tags</Link>
        <Typography color="textPrimary">
          {error ? error : data ? data.name : "Loading"}
        </Typography>
      </Breadcrumbs>
      {data && (
        <PostTagForm
          type="update"
          initialValues={data}
          onSubmit={async (values) => {
            await updateTag(tagId, values, "interview");
          }}
          onDelete={async () => {
            await deleteTag(tagId, "interview");
            props.history.push("/interview-tags");
          }}
        />
      )}
    </Layout>
  );
}
